import { request, type Variables } from 'graphql-request';

import { getGraphQlEndpoint } from '@/api/backendAPI';

import { getCookie } from './cookie';

const gqlRequest = async <T = unknown>(
  query: string,
  vars?: Variables,
): Promise<T> => {
  const url = getGraphQlEndpoint()!;
  const statsigStableId = getCookie('statsigStableId') ?? '';
  const country = getCookie('countryCode') ?? '';

  const headers = {
    'x-statsig-stable-id': statsigStableId,
    'x-country': country,
  };

  return request<T>(url, query, vars, headers);
};

export default gqlRequest;
